export const BUILDER_CONFIG = {
	publicKey: process.env.NEXT_PUBLIC_BUILDERIO_API_KEY as string,
};

export type StoreRegion = "global" | "ca" | "us" | "eu";
